<template>
  <div id="errorPage">
    <el-image class="errorCls" fit="fill" :src="require('@/assets/error404.png')"></el-image>
  </div>
</template>

<script>
export default {
  name: 'errorPage',
  data() {
    return {

    };
  }
}
</script>

<style scoped>
#errorPage{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.errorCls {
  width: 50%;
  height: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/error/errorPage.vue